import React from 'react';
import PropTypes from 'prop-types';

const DashboardBox = ({
  title, link, count, boxBgColor, boxColor, smallBoxClass, iconName,
}) => (
  <div className="col-lg-3 col-xs-6 dashboard-boxes">
    <div className={`small-box ${smallBoxClass}`} style={{ backgroundColor: boxBgColor, color: boxColor }}>
      <div className="inner">
        <div className="counter-box">
          <h3 className="number_count">{count}</h3>
        </div>
        <p>{ title }</p>
      </div>
      <i className={`fa fa-${iconName} icon`} />
      <a
        href={link}
        className="small-box-footer"
        title="More Information"
      >
        More info
        {' '}
        <i className="fa fa-arrow-circle-right" />
      </a>
    </div>
  </div>
);

DashboardBox.propTypes = {
  title: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  iconName: PropTypes.string.isRequired,
  boxBgColor: PropTypes.string,
  boxColor: PropTypes.string,
  smallBoxClass: PropTypes.string,
};

DashboardBox.defaultProps = {
  boxBgColor: '',
  boxColor: '',
  smallBoxClass: '',
};

export default DashboardBox;
